import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

import './index.css';

// eslint-disable-next-line no-unused-vars


const rootElement = document.getElementById('root');
rootElement.style.position = 'relative';
rootElement.style.overflow = 'visible';
rootElement.style.height = '100vh';
rootElement.style.minHeight = '100%';

const root = ReactDOM.createRoot(rootElement);
root.render(
  <HelmetProvider>
  <Router>
    <AuthProvider>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </AuthProvider>
  </Router>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
